import HttpClient from "../../clients/HttpClient";
import { tspKeyEnum } from "../../models/tspKeyEnum";

export default class KintoService {
  static httpClient: HttpClient = HttpClient.getInstance("backend", process.env.REACT_APP_API_URL);

  public static async uploadDriveData(file: File): Promise<boolean> {
    const formData = new FormData();
    formData.append('file', file);
    const res = await this.httpClient.call('POST', `/kinto/sync`, formData, {}, {
      'Content-Type': 'multipart/form-data',
    }, false);
    return res.status >= 200 && res.status < 300;
  }
}

